import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AuthenticationService} from '../../../shared/services/authentication/authentication.service';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {Subscription} from 'rxjs/Subscription';
import {User} from '../../../shared/eloquent/models/user.model';
import {LayoutService} from '../../../shared/services/layout/layout.service';

declare let $: any;

@Component({
    selector: 'app-authenticated-wrapper',
    templateUrl: './authenticated-wrapper.component.html',
    styleUrls: ['./authenticated-wrapper.component.scss']
})
export class AuthenticatedWrapperComponent implements OnInit, AfterViewInit, OnDestroy {

    @ViewChild('sidebar')
    sidebar: ElementRef;

    user: User;
    pageTitle = 'İmalat Planlama';
    ADMIN_ROLE = AuthenticationService.ROLES.ADMIN;
    EDITING_ROLE = AuthenticationService.ROLES.EDITING;
    VIEWING_ROLE = AuthenticationService.ROLES.VIEWING;

    private userSubscripton: Subscription;
    private routerSubscripton: Subscription;
    private pageTitleSubscripton: Subscription;

    constructor(private authenticationService: AuthenticationService,
                private router: Router,
                private layoutService: LayoutService) {
        this.subscribeRouterEvents();
        this.subscribeUser();
        this.subscribePageTitle();
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        $(this.sidebar.nativeElement).sidebar({
            transition: 'overlay'
        });
    }


    ngOnDestroy(): void {
        this.unsubscribeRouterEvents();
        this.unsubscribeUser();
        this.unsubscribePageTitle();
    }

    toggleSidebar = () => {
        $(this.sidebar.nativeElement).sidebar('toggle');
    };

    public userHasRole(roles: Array<number>): boolean {
        return this.authenticationService.userHasRole(roles);
    }

    private subscribeRouterEvents() {
        this.routerSubscripton = this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((val) => {
            $(this.sidebar.nativeElement).sidebar('hide');
        });
    }

    private subscribeUser() {
        this.userSubscripton = this.authenticationService.user.subscribe((user) => {
            this.user = user;
        });
    }

    private subscribePageTitle() {
        this.pageTitleSubscripton = this.layoutService.title.subscribe((title) => this.pageTitle = title);
    }


    private unsubscribeRouterEvents() {
        this.routerSubscripton.unsubscribe();
    }

    private unsubscribeUser() {
        this.userSubscripton.unsubscribe();
    }

    private unsubscribePageTitle() {

    }
}



// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/components/authenticated/authenticated-wrapper/authenticated-wrapper.component.ts